module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 8.063 11.15",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#arrow",
      toString: function () {
        return this.url;
      }
    }